var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id && _vm.titulos && _vm.valores)?_c('div',{staticClass:"chart-container"},[_c('canvas',{attrs:{"id":_vm.id}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }